module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_library.js
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8